const AI = () =>
  import('@/views/main/helper/ai/AI.vue')
export default {
  path: '/main/helper/ai',
  name: 'AI',
  component: AI,
  children: []
}
